import { render, staticRenderFns } from "./annualbudgetfullv2.vue?vue&type=template&id=b523df7e&scoped=true"
import script from "./annualbudgetfullv2.vue?vue&type=script&lang=js"
export * from "./annualbudgetfullv2.vue?vue&type=script&lang=js"
import style0 from "./annualbudgetfullv2.vue?vue&type=style&index=0&id=b523df7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b523df7e",
  null
  
)

export default component.exports